import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton, TextField, Typography } from "@mui/material";
import { CloseIcon } from "../icons/CloseIcon";
import { useTranslation } from "react-i18next";

export const ModalConfirmPageWithinput = ({ open, setOpen, text, placeholder, call }) => {
  const [value, setValue] = useState(text);
  const { t } = useTranslation();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        className="modal-title-right"
        sx={{
          justifyContent: "space-between !important",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "20px !important", fontWeight: 500 }}>{"Подтверждение"}</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ width: "500px" }}>
        <DialogContentText id="alert-dialog-description" mb={"24px"}>
          {text}
        </DialogContentText>
        <TextField
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={t(placeholder)}
          autoFocus
          onClick={(e) => e.stopPropagation()}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            call(value);
            setValue("");
          }}
          color="primary"
          autoFocus
          className="btn btn-primary-fill"
        >
          Отправить
        </Button>
      </DialogActions>
    </Dialog>
  );
};
